import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    oldPasswordRequired: translate({
      id: 'settings.rmAccount.view.changePasswordModal.errors.required',
    }),
  }))

  return api
}

export type ValidationTexts = ReturnType<typeof useTexts>
